// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"448d35c3","453":"8f7715c9","667":"5724b17e","821":"93ac4564"}[chunkId] + ".chunk.js";
};